import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
  FaRegHeart,
  FaRegUser,
} from "react-icons/fa";
import { BsCart } from "react-icons/bs";
import "../assets/styles/Header.css";
import { useCart } from "../context/CartContext";
import { useWishlist } from "../context/WishlistContext";
import { BaseUrl } from "../config/api";

const Header = () => {
  const { toggleCart, cartItems } = useCart();
  const { wishlistItems } = useWishlist();
  const [announcementIndex, setAnnouncementIndex] = useState(0);
  const [announcements, setAnnouncements] = useState([]);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleNavLinkClick = () => {
    setIsMobileMenuOpen(false);
  };

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const response = await fetch(`${BaseUrl}/marketing/getallcontents`);
        if (!response.ok) {
          console.error("Failed to fetch announcements:", response.status);
          return;
        }
        const data = await response.json();
        if (Array.isArray(data)) {
          setAnnouncements(data.map((item) => item.content));
        }
      } catch (error) {
        console.error("Error fetching announcements:", error);
      }
    };

    fetchAnnouncements();
  }, []);

  useEffect(() => {
    if (announcements.length > 1) {
      const timer = setInterval(() => {
        setAnnouncementIndex((prev) => (prev + 1) % announcements.length);
      }, 3000);

      return () => clearInterval(timer);
    }
  }, [announcements]);

  return (
    <>
      {announcements.length > 0 && (
        <div className="announcement-bar">
          <div className="announcement-text">
            {announcements[announcementIndex]}
          </div>
          <div className="social-icons">
            <a href="#" target="_blank" rel="noopener noreferrer">
              <FaFacebook />
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer">
              <FaLinkedin />
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer">
              <FaTwitter />
            </a>
          </div>
        </div>
      )}
      <header className="header">
        <div className="header-container">
          <div className="logo">
            <Link to="/">
              <img src="/logo.jpg" alt="Shine in Lavender" />
            </Link>
          </div>
          <button
            className={`mobile-menu-btn ${isMobileMenuOpen ? "open" : ""}`}
            onClick={toggleMobileMenu}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          <div
            className={`mobile-menu-overlay ${
              isMobileMenuOpen ? "active" : ""
            }`}
            onClick={toggleMobileMenu}
          ></div>
          <nav className={`nav-menu ${isMobileMenuOpen ? "mobile-open" : ""}`}>
            <NavLink to="/" onClick={handleNavLinkClick}>
              HOME
            </NavLink>
            <NavLink to="/new-collections" onClick={handleNavLinkClick}>
              NEW COLLECTIONS
            </NavLink>
            {/* <NavLink to="/women">WOMEN</NavLink> */}
            <NavLink to="/products" onClick={handleNavLinkClick}>
              PRODUCT CATEGORY
            </NavLink>
            {/* <NavLink to="/services">SEWING SERVICES</NavLink> */}
          </nav>
          <div className="header-actions">
            <Link to="/favourites">
              <button className="wishlist-btn">
                <FaRegHeart />
                {wishlistItems.length > 0 && (
                  <span className="header-wishlist-count">
                    {wishlistItems.length}
                  </span>
                )}
              </button>
            </Link>
            {/* <Link to="/my-account">
              <button className="account-btn">
                <FaRegUser />
              </button>
            </Link> */}
            <button className="cart-btn" onClick={toggleCart}>
              <BsCart />
              {cartItems.length > 0 && (
                <span className="header-cart-count">{cartItems.length}</span>
              )}
            </button>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
